import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
const state = {
  // 加油枪号
  list: [],
  addressInfo: {},
  takerInfo: {},
  orderCoupon: {
    couponId: '',
    couponName: '',
    price: 0
  },
  invoiceTitle: {
    title: '',
    id: ''
  }
}
export default {
  getters,
  actions,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/stores/mall/index.js